import React, { FC } from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import BankCardLight from '../../../../assets/images/cards/BankCardLight.png';
import BankCardDark from '../../../../assets/images/cards/BankCardDark.png';

export const BankCard: FC = () => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'light': {
        return BankCardLight;
      }
      case 'dark': {
        return BankCardDark;
      }
      default: {
        return BankCardLight;
      }
    }
  };
  return <img src={getIcon(theme)} alt="bank card" />;
};
